import React from 'react'
import { FormattedMessage } from 'react-intl'

import pinpad from '@/checkout-instore-legacy/assets/images/barcode-ismp.svg'

export default function ISMPIndicator() {
  return (
    <div className="tc mt6 f4-ns gray">
      <div className="lh-copy mb6">
        <FormattedMessage id="selectSideButtons" />
        <br />
        <FormattedMessage id="toAddProducts" />
      </div>
      <img className="image" src={pinpad} />
    </div>
  )
}
